import { Check, Globe } from '@digital-twins/design-system/icons'
import { useTranslation } from 'react-i18next'

import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu'
import { setUiLanguage, UI_LANGUAGES, resolveUiLanguage } from '@/i18n'
import type { UiLanguage } from '@/i18n'

const NATIVE_LABELS: Record<UiLanguage, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  'pt-BR': 'Português',
}

interface UiLanguageMenuItemsProps {
  itemClassName?: string
}

export function UiLanguageMenuItems({ itemClassName }: UiLanguageMenuItemsProps) {
  const { t, i18n } = useTranslation('app')
  const current: UiLanguage = resolveUiLanguage(i18n.language)

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className={itemClassName} data-testid="avatar-language-menu">
        <Globe className="h-4 w-4" strokeWidth={1.5} />
        <span>{t('nav.language')}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="bg-background">
        {UI_LANGUAGES.map((code) => (
          <DropdownMenuItem
            key={code}
            data-testid={`avatar-language-${code}`}
            onClick={() => {
              void setUiLanguage(code)
            }}
            className={itemClassName}
          >
            <span className="flex-1">{NATIVE_LABELS[code]}</span>
            {current === code ? <Check className="h-4 w-4" strokeWidth={1.5} /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
